import { createFileRoute } from '@tanstack/react-router'
import { SettingsPanel } from '@/features/settings/SettingsPanel'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Settings" />
      <div className="mt-6">
        <SettingsPanel />
      </div>
    </div>
  )
}
